import { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../api";

const S = {
  page: { minHeight:"100vh", background:"#050510", display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"'DM Sans',sans-serif", padding:20 },
  box:  { background:"linear-gradient(135deg,#0d0d1f,#111128)", border:"1px solid #00d4aa22", borderRadius:24, padding:40, width:"100%", maxWidth:440 },
  inp:  { width:"100%", background:"#050510", border:"1px solid #ffffff22", borderRadius:10, padding:"13px 16px", color:"#fff", fontSize:15, outline:"none", boxSizing:"border-box", fontFamily:"'DM Sans',sans-serif" },
  btn:  { width:"100%", background:"linear-gradient(135deg,#00d4aa,#00b894)", color:"#050510", border:"none", borderRadius:12, padding:15, fontWeight:700, fontSize:16, cursor:"pointer", fontFamily:"'DM Sans',sans-serif" },
  lbl:  { display:"block", color:"#9ca3af", fontSize:12, marginBottom:8, textTransform:"uppercase", letterSpacing:1 },
};

export default function Signup() {
  const [step, setStep]         = useState(1); // 1=form, 2=otp
  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm]   = useState("");
  const [otp, setOtp]           = useState("");
  const [token, setToken]       = useState("");
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState("");
  const navigate = useNavigate();

  const signup = async () => {
    if (!email || !password || !confirm) { setError("Fill in all fields."); return; }
    if (password !== confirm) { setError("Passwords do not match."); return; }
    if (password.length < 6) { setError("Password must be at least 6 characters."); return; }
    setLoading(true); setError("");
    try {
      const res = await API.post("/signup", { email, password });
      setToken(res.data.token);
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("email", res.data.email);
      if (res.data.needs_verification) {
        setStep(2); // Show OTP verification
      } else {
        window.location.href = "/dashboard";
      }
    } catch (err) {
      setError(err?.response?.data?.detail || "Signup failed.");
    }
    setLoading(false);
  };

  const verifyOtp = async () => {
    if (!otp || otp.length < 6) { setError("Enter the 6-digit OTP."); return; }
    setLoading(true); setError("");
    try {
      await API.post("/verify-otp", { email, otp });
      window.location.href = "/dashboard";
    } catch (err) {
      setError(err?.response?.data?.detail || "Invalid OTP. Check your email.");
    }
    setLoading(false);
  };

  const resendOtp = async () => {
    try {
      await API.post("/resend-otp", { email });
      setError("");
      alert("New OTP sent to " + email);
    } catch(e) {
      setError("Failed to resend OTP.");
    }
  };

  return (
    <div style={S.page}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;700&family=Syne:wght@900&display=swap" rel="stylesheet"/>
      <div style={{ width:"100%", maxWidth:440 }}>
        <div style={{ textAlign:"center", marginBottom:32 }}>
          <div style={{ fontFamily:"'Syne',sans-serif", fontSize:28, fontWeight:900, color:"#00d4aa", marginBottom:8 }}>⚡ LeadBot Pro</div>
          <div style={{ display:"inline-block", background:"#00d4aa22", border:"1px solid #00d4aa44", borderRadius:20, padding:"5px 14px", fontSize:13, color:"#00d4aa", marginBottom:8 }}>
            🎁 2 Free Searches — No Card Required
          </div>
          <p style={{ color:"#6b7280", margin:0, fontSize:14 }}>
            {step === 1 ? "Create your free account" : "Verify your email address"}
          </p>
        </div>

        <div style={S.box}>
          {step === 1 ? (
            <>
              <div style={{ marginBottom:16 }}>
                <label style={S.lbl}>Email</label>
                <input style={S.inp} type="email" placeholder="you@example.com" value={email} onChange={e => setEmail(e.target.value)} autoFocus/>
              </div>
              <div style={{ marginBottom:16 }}>
                <label style={S.lbl}>Password</label>
                <input style={S.inp} type="password" placeholder="Min 6 characters" value={password} onChange={e => setPassword(e.target.value)}/>
              </div>
              <div style={{ marginBottom:24 }}>
                <label style={S.lbl}>Confirm Password</label>
                <input style={S.inp} type="password" placeholder="Repeat password" value={confirm} onChange={e => setConfirm(e.target.value)} onKeyDown={e => e.key==="Enter" && signup()}/>
              </div>
              {error && <div style={{ background:"#f8717118", border:"1px solid #f8717144", borderRadius:10, padding:"10px 14px", color:"#f87171", fontSize:13, marginBottom:16 }}>{error}</div>}
              <button style={{ ...S.btn, opacity: loading?0.6:1 }} onClick={signup} disabled={loading}>
                {loading ? "Creating account..." : "🎯 Create Account →"}
              </button>
            </>
          ) : (
            <>
              {/* OTP Step */}
              <div style={{ textAlign:"center", marginBottom:24 }}>
                <div style={{ fontSize:40, marginBottom:12 }}>📧</div>
                <div style={{ color:"#fff", fontWeight:700, fontSize:16, marginBottom:6 }}>Check your email!</div>
                <div style={{ color:"#9ca3af", fontSize:14 }}>
                  We sent a 6-digit OTP to<br/>
                  <strong style={{ color:"#00d4aa" }}>{email}</strong>
                </div>
              </div>
              <div style={{ marginBottom:24 }}>
                <label style={S.lbl}>Enter OTP Code</label>
                <input
                  style={{ ...S.inp, fontSize:28, letterSpacing:12, textAlign:"center", fontWeight:700 }}
                  type="text"
                  placeholder="······"
                  value={otp}
                  onChange={e => setOtp(e.target.value.replace(/\D/g,"").slice(0,6))}
                  onKeyDown={e => e.key==="Enter" && verifyOtp()}
                  maxLength={6}
                  autoFocus
                />
              </div>
              {error && <div style={{ background:"#f8717118", border:"1px solid #f8717144", borderRadius:10, padding:"10px 14px", color:"#f87171", fontSize:13, marginBottom:16 }}>{error}</div>}
              <button style={{ ...S.btn, opacity: loading?0.6:1 }} onClick={verifyOtp} disabled={loading}>
                {loading ? "Verifying..." : "✅ Verify & Get Leads →"}
              </button>
              <p style={{ textAlign:"center", marginTop:16, color:"#6b7280", fontSize:13 }}>
                Didn't receive it?{" "}
                <span onClick={resendOtp} style={{ color:"#00d4aa", cursor:"pointer", fontWeight:700 }}>Resend OTP</span>
                {" · "}
                <span onClick={() => setStep(1)} style={{ color:"#9ca3af", cursor:"pointer" }}>Change email</span>
              </p>
            </>
          )}

          <p style={{ textAlign:"center", marginTop:20, color:"#6b7280", fontSize:14 }}>
            Already have an account?{" "}
            <span onClick={() => navigate("/login")} style={{ color:"#00d4aa", cursor:"pointer", fontWeight:700 }}>Sign in</span>
          </p>
        </div>

        <div style={{ display:"flex", justifyContent:"center", gap:24, marginTop:20 }}>
          {["No credit card","2 free searches","Real phone numbers"].map((t,i) => (
            <div key={i} style={{ fontSize:12, color:"#4b5563", display:"flex", alignItems:"center", gap:4 }}>
              <span style={{ color:"#00d4aa" }}>✓</span>{t}
            </div>
          ))}
        </div>
        <p onClick={() => navigate("/")} style={{ textAlign:"center", marginTop:16, color:"#4b5563", fontSize:13, cursor:"pointer" }}>← Back to home</p>
      </div>
    </div>
  );
}
